import React, { useState, useContext } from 'react';
import { useSelector } from 'react-redux';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
} from '@mui/material';
import { Button } from '@/shared/components/Button';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useHistory } from 'react-router-dom';
import { logout as logoutAuth0 } from '@/shared/components/account/auth/withAuth0';
import {
 colorBackground, colorHover, colorText, colorBorder,
} from '@/utils/palette'; // Ensure correct imports
import toast from 'react-hot-toast';
import { Collapse, Col } from 'react-bootstrap';
import styled from 'styled-components';
import { marginLeft, right, left } from '@/utils/directions';
import TopbarMenuLink, { TopbarLink } from './TopbarMenuLink';
import { TopbarBack, TopbarDownIcon } from './BasicTopbarComponents';
import { AuthContext } from '../../../../context/AuthContext';
import { GlobalVarContext } from '../../../../context/GlobalVarContext';
// import { GlobalContext } from '../../../../context/GlobalContext';
 
// Your component code goes here
 
 
const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);
 
const TopbarProfile = () => {
  const history = useHistory();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const user = useSelector(state => state.user);
 
  // State variables for form fields
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
  // const { apiGlobal } = useContext(GlobalContext);

  const toggleProfile = () => {
    setIsCollapsed(!isCollapsed);
  };
 
  const logout = () => {
    localStorage.removeItem('easydev');
    logoutAuth0();
  };
 
  const { username, userid, apiGlobal } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
 
  const handleClickOpen = () => {
    setOpen(true);
    toggleProfile();
  };
 
  const handleClose = () => {
    setOpen(false);
  };
 
 
 
 
  const handlePassWordChange = async () => {
    const formData = new FormData();
    formData.append('id', userid); // Ensure 'userid' is defined, either in state or passed as prop.
    formData.append('current_password', currentPassword);
    formData.append('new_password', newPassword);
    formData.append('confirm_password', confirmNewPassword);
 
    try {
      const response = await fetch(`${apiGlobal}/restaurant/user_restaurant_pass_change.php`, {
        method: 'POST',
        body: formData,
      });
 
      if (!response.ok) {
        // Handle error if response is not OK (e.g., 400 or 500 errors)
        throw new Error('Password change failed. Please try again later.');
      }
 
      const result = await response.json();
      if (result.status && result.message === 'Record updated successfully.') {
        // Show success message if the API returns success
        toast.success('Password successfully changed!');
        handleClose();
      } else {
        // Handle API response failure (e.g., invalid current password)
        toast.error(result.message || 'An error occurred while changing the password.');
      }
    } catch (error) {
      // Log error and show a toast for unexpected errors
      console.error(error);
      toast.error('An error occurred. Please try again later.');
    } finally {
       // Close the modal or dialog after handling the password change
      setCurrentPassword('');
      setNewPassword('');
      setConfirmNewPassword('');
    }
  };
 
  function truncateUsername(usernames, maxLength = 15) {
    return username.length > maxLength ? `${usernames.substring(0, maxLength) }...` : usernames;
}
  const [profilePic, setProfilePic] = useState(`${apiGlobal}images/admin/user.png`);
 
  // Handlers for password visibility toggle
  const handleClickShowCurrentPassword = () => setShowCurrentPassword(prevState => !prevState);
  const handleClickShowNewPassword = () => setShowNewPassword(prevState => !prevState);
  const handleClickShowConfirmNewPassword = () => setShowConfirmNewPassword(prevState => !prevState);
 
  return (
    <div>
      <TopbarProfileWrap>
        <TopbarAvatarButton
          type="button"
          onClick={toggleProfile}
          style={{
            width: '200px',
          }}
        >
          <TopbarAvatarImage
            src={profilePic}
            alt="avatar"
          />
          <TopbarAvatarName>
            {truncateUsername(username)}
            {/* {username} */}
          </TopbarAvatarName>
          <TopbarDownIcon />
        </TopbarAvatarButton>
        {isCollapsed && (
          <TopbarBack
            type="button"
            aria-label="profile button"
            onClick={toggleProfile}
          />
        )}
        <Collapse in={isCollapsed}>
          <TopbarMenuWrap>
            <TopbarMenu>
              <TopbarMenuLink
                title="Change Password"
                icon="user"
                onClick={() => handleClickOpen()}
              />
            </TopbarMenu>
          </TopbarMenuWrap>
        </Collapse>
      </TopbarProfileWrap>
 
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        className="rounded"
      >
        <DialogTitle>Change Password</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary" paragraph>
            Please enter your current password and new password.
          </Typography>
          <Col md={12} lg={12}>
            <form>
              {/* Current Password Field */}
              <TextField
                label="Current Password"
                type={showCurrentPassword ? 'text' : 'password'}
                fullWidth
                variant="outlined"
                margin="normal"
                value={currentPassword}
                onChange={e => setCurrentPassword(e.target.value)}
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowCurrentPassword}
                        edge="end"
                      >
                        {showCurrentPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
 
              {/* New Password Field */}
              <TextField
                label="New Password"
                type={showNewPassword ? 'text' : 'password'}
                fullWidth
                variant="outlined"
                margin="normal"
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowNewPassword}
                        edge="end"
                      >
                        {showNewPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
 
              {/* Confirm New Password Field */}
              <TextField
                label="Confirm New Password"
                type={showConfirmNewPassword ? 'text' : 'password'}
                fullWidth
                variant="outlined"
                margin="normal"
                value={confirmNewPassword}
                onChange={e => setConfirmNewPassword(e.target.value)}
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowConfirmNewPassword}
                        edge="end"
                      >
                        {showConfirmNewPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </form>
          </Col>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handlePassWordChange({ currPassword: currentPassword, newPassword, confirmNewPassword })}
            type="button"
            variant="success"
          >
            Change
          </Button>
          <Button onClick={handleClose} type="button" variant="danger">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
 
export default TopbarProfile;
 
// region STYLES
 
export const TopbarProfileWrap = styled.div`
  position: relative;
  margin-bottom: 0;
  padding: 0;
  @media screen and (max-width: 576px) {
    margin: inherit;
  }
 
  @media screen and (max-width: 320px) {
    margin: auto 0;
  }
`;
 
const TopbarAvatarButton = styled.button`
  height: 100%;
  display: flex;
  cursor: pointer;
  position: relative;
  border-radius: 0;
  border: none;
  transition: all 0.3s;
  box-shadow: none;
  padding: 0 15px;
  background-color: transparent;
 
  &:hover, &:focus, &:active, &:focus:active {
    background-color: ${colorHover};
  }
 
  &:focus {
    outline: none;
  }
 
  &:before {
    display: none;
  }
`;
 
const TopbarAvatarImage = styled.img`
  margin: auto 0;
  border-radius: 50%;
  height: 36px;
  width: 36px;
`;
 
export const TopbarAvatarName = styled.p`
  margin: auto 0;
  font-size: 13px;
  line-height: 18px;
  font-weight: 400;
  display: none;
  color: ${colorText};
 
  @media screen and (min-width: 480px) {
    display: block;
  }
`;
 
const TopbarMenuWrap = styled.div`
  z-index: 101;
  position: absolute;
  width: 100%;
  min-width: 210px;
  right: 0;
`;
 
const TopbarMenu = styled.div`
  width: 200px;
  border-radius: 0;
  border: none;
  padding: 15px 0;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.05);
  background: ${colorBackground};
`;
 
const TopbarMenuDivider = styled.div`
  margin: 15px 0;
  border-top: 1px solid ${colorBorder};
`; 


// import React, { useState, useContext } from 'react';
// import { Collapse } from 'react-bootstrap';
// import { useSelector } from 'react-redux';
// import styled from 'styled-components';
// import { useHistory } from 'react-router-dom';
// import { logout as logoutAuth0 } from '@/shared/components/account/auth/withAuth0';
// import {
//  colorBackground, colorHover, colorText, colorBorder, 
// } from '@/utils/palette';
// import toast from 'react-hot-toast';
// import { marginLeft, right, left } from '@/utils/directions';
// import { TopbarBack, TopbarDownIcon } from './BasicTopbarComponents';
// import TopbarMenuLink, { TopbarLink } from './TopbarMenuLink';
// import { AuthContext } from '../../../../context/AuthContext';


// const Ava = `${process.env.PUBLIC_URL}/img/ava.png`;

// const TopbarProfile = () => {
//   const history = useHistory();
//   const [isCollapsed, setIsCollapsed] = useState(false);
//   const user = useSelector(state => state.user);

//   const toggleProfile = () => {
//     setIsCollapsed(!isCollapsed);
//   };

//   const logout = () => {
//     localStorage.removeItem('easydev');
//     logoutAuth0();
//   };

//   const { username } = useContext(AuthContext);

//    const [profilePic, setProfilePic] = useState('https://navrang.mvd-tech.io/API/images/admin/user.png');

//   return (
//     <TopbarProfileWrap>
//       <TopbarAvatarButton type="button" onClick={toggleProfile}>
//         <TopbarAvatarImage
//           src={profilePic}
//           alt="avatar"
//         />
//         <TopbarAvatarName>
//           {username}
//         </TopbarAvatarName>
//         <TopbarDownIcon />
//       </TopbarAvatarButton>
//       {/* {isCollapsed && (
//         <TopbarBack
//           type="button"
//           aria-label="profile button"
//           onClick={toggleProfile}
//         />
//       )} */}
//       {/* <Collapse in={isCollapsed}>
//         <TopbarMenuWrap>
//           <TopbarMenu>
//             <TopbarMenuLink
//               title="My Profile"
//               icon="user"
//               path="/account/profile"
//               onClick={toggleProfile}
//             />
//             <TopbarMenuLink
//               title="Calendar"
//               icon="calendar-full"
//               path="/default_pages/calendar"
//               onClick={toggleProfile}
//             />
//             <TopbarMenuLink
//               title="Tasks"
//               icon="list"
//               path="/todo"
//               onClick={toggleProfile}
//             />
//             <TopbarMenuLink
//               title="Inbox"
//               icon="inbox"
//               path="/mail"
//               onClick={toggleProfile}
//             />
//             <TopbarMenuDivider />
//             <TopbarMenuLink
//               title="Account Settings"
//               icon="cog"
//               path="/account/profile"
//               onClick={toggleProfile}
//             />
//             <TopbarMenuLink
//               title="Lock Screen"
//               icon="lock"
//               onClick={toggleProfile}
//             />
//             <TopbarMenuLink
//               title="Log Out"
//               icon="exit"
//               path="/log_in"
//               onClick={logout}
//             />
//           </TopbarMenu>
//         </TopbarMenuWrap>
//       </Collapse> */}
//     </TopbarProfileWrap>
//   );
// };

// export default TopbarProfile;

// // region STYLES

// export const TopbarProfileWrap = styled.div`
//   position: relative;
//   margin-bottom: 0;
//   ${marginLeft}: 0;

//   @media screen and (max-width: 576px) {
//     margin: inherit;
//   }

//   @media screen and (max-width: 320px) {
//     margin: auto 0;
//   }
// `;

// const TopbarAvatarButton = styled.button`
//   height: 100%;
//   display: flex;
//   cursor: pointer;
//   position: relative;
//   border-radius: 0;
//   border: none;
//   transition: all 0.3s;
//   box-shadow: none;
//   padding: 0 15px;
//   background-color: transparent;

//   &:hover, &:focus, &:active, &:focus:active {
//     background-color: ${colorHover};
//   }

//   &:focus {
//     outline: none;
//   }

//   &:before {
//     display: none;
//   }  
// `;

// const TopbarAvatarImage = styled.img`
//   margin: auto 0;
//   border-radius: 50%;
//   height: 36px;
//   width: 36px;
// `;

// export const TopbarAvatarName = styled.p`
//   margin: auto 0;
//   font-size: 13px;
//   line-height: 18px;
//   font-weight: 400;
//   display: none;
//   ${marginLeft}: 10px;
//   color: ${colorText};

//   @media screen and (min-width: 480px) {
//       display: block;
//   }
// `;

// const TopbarMenuWrap = styled.div`
//   z-index: 101;
//   position: absolute;
//   width: 100%;
//   min-width: 210px;
//   ${right}: 0;

//   @media screen and (max-width: 320px) {
//     ${right}: -50px;
//   }
// `;

// const TopbarMenu = styled.div`
//   width: 200px;
//   border-radius: 0;
//   border: none;
//   padding: 15px 0;
//   box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.05);
//   margin-top: 0;
//   background: ${colorBackground};

//   button {
//     padding: 0;

//     &:hover {
//       background-color: ${colorHover};
//     }

//     &${TopbarLink} {
//       background-color: transparent;
//       border: none;
//       padding: 9px 20px;
//     }
//   }

//   *:focus {
//     outline: none;
//   }

//   @media screen and (min-width: 480px) {
//     width: 100%;
//     ${left}: 0 !important;
//   }
// `;

// const TopbarMenuDivider = styled.div`
//   margin: 15px 0;
//   border-top: 1px solid ${colorBorder};
// `;

// // endregion
